<template>
	<QaLayout>
		<QaItem2/>
	</QaLayout>
</template>

<script>
import QaItem2 from './qaItem2.vue';
import QaLayout from './qaLayout.vue';
export default {
	components: {
		QaLayout,
		QaItem2
	}
}
</script>
